module.exports = __webpack_public_path__ + "img/engine.2e4869bd.svg";